module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: ['mask', _vm.openDrawer ? 'open' : 'close'],
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    class: ['drawer', _vm.placement, _vm.openDrawer ? 'open' : 'close']
  }, [_c('div', {
    ref: "drawer",
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showHandler) ? _c('div', {
    ref: "handler",
    class: ['handler-container', _vm.placement]
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2d50d875","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/Drawer.vue
// module id = ag3w
// module chunks = 273